import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import cn from 'classnames'

import Dropdown from 'react-toolbox/lib/dropdown';

import styles from './styles.scss'

const DropdownComponent = ({ className, label, source, value, onChange, disabled }) => {
    const classes = cn(className, cn)
    return (
        <Dropdown
            class={classes}
            auto={false}
            theme={styles}
            label={label}
            onChange={onChange}
            source={source}
            value={value}
            disabled={disabled}
        />
    )
}

DropdownComponent.defaultProps = {
    disabled: false,
}

const withStyle = CSSModules(styles)
export default withStyle(DropdownComponent)